import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import videojs from '!video.js';
import './videojs-hotkeys';
import './videojs-overlay';
import './videojs-watermark';
import './videojs-landscape-fullscreen';
import 'video.js/dist/video-js.css';
import muvikaAttrs from './../../attrs';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import IosVolumeControl from './../../services/volume';
import { Capacitor } from '@capacitor/core';
import { lockOrientation } from '../../services/screen';
import MuvikaService from './../../services/muvika';
import { useMediaQuery } from 'react-responsive';
import TR from './../../Trans';
import TopBarPlayer from './TopBarPlayer';
import { throttle } from '../../services/throttle';
import { checkIfMobile } from '../../services/screen';
import IntervalService from './../../services/intervals';
import sessionStore from '../../stores/session';
import playerStore from '../../stores/player';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import statusStore from './../../stores/status';
import newTracksStore from './../../stores/newTracks';
import navigationStore from '../../stores/navigation';
import timeoutsStore from './../../stores/timeouts';
import musicPlayerStore from '../../stores/musicPlayer';

export const VideoPlayer = (props) => {


  const sessionToken = sessionStore((state) => state.sessionToken);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const playQueue = performanceStore((state) => state.playQueue);
  const setOn = performanceStore((state) => state.setOn);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const isPlaying = playerStore((state) => state.isPlaying);
  const empty = playerStore((state) => state.empty);
  const isStopped = playerStore((state) => state.isStopped);
  const getNextPerformance = performanceStore((state) => state.getNextPerformance);
  //const currentTime = playerStore((state) => state.currentTime);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const setFullScreen = playerStore((state) => state.setFullScreen);
  const streamUrl = playerStore((state) => state.streamUrl);
  const isOn = performanceStore((state) => state.isOn);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const currentTrack = playerStore((state) => state.currentTrack);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  //const countdown = performanceStore((state) => state.countdown);
  const setCountdown = performanceStore((state) => state.setCountdown);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const setNextPerformance = performanceStore((state) => state.setNextPerformance);
  const setCurrentPerformance = performanceStore((state) => state.setCurrentPerformance);
  const currentPerformanceId = playerStore((state) => state.currentPerformanceId);
  const currentPitch = playerStore((state) => state.currentPitch);
  const pitchRecog = playerStore((state) => state.pitchRecog);
  const currentVersion = playerStore((state) => state.currentVersion);
  const setCurrentPitch = playerStore((state) => state.setCurrentPitch);
  const setCurrentVersion = playerStore((state) => state.setCurrentVersion);
  const isInExternalWindow = playerStore((state) => state.isInExternalWindow);
  const setIsInExternalWindow = playerStore((state) => state.setIsInExternalWindow);
  const isPlayListOn = performanceStore((state) => state.isOn);
  const isFullScreen = playerStore((state) => state.isFullScreen);
  const from = playerStore((state) => state.from);
  const setVolume = playerStore((state) => state.setVolume);
  const currentVolume = playerStore((state) => state.currentVolume);
  const trackEnded = playerStore((state) => state.trackEnded);
  const isAutoPlayOn = playerStore((state) => state.isAutoPlayOn);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const isTrackLogSent = playerStore((state) => state.isTrackLogSent);
  const setIsTrackLogSent = playerStore((state) => state.setIsTrackLogSent);
  const isFocused = playerStore((state) => state.isFocused);
  const isFirstRender = navigationStore((state) => state.isPlayerFirstRender);
  const setIsFirstRender = navigationStore((state) => state.setIsPlayerFirstRender);
  const setAppStatus = statusStore((state) => state.setAppStatus);
  const setPlayerStatus = statusStore((state) => state.setPlayerStatus);
  const isPitchEditable = playerStore((state) => state.isPitchEditable);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const isSwitching = playerStore((state) => state.isSwitching);
  const setCurrentBuffer = playerStore((state) => state.setCurrentBuffer);
  const isSmallVideo = playerStore((state) => state.isSmallVideo);
  const prevFromHistory = performanceStore((state) => state.prevFromHistory);
  const isCasting = playerStore((state) => state.isCasting);
  const setCurrentPerformancePitch = performanceStore((state) => state.setCurrentPerformancePitch);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const setSettings = settingsStore((state) => state.setSettings);
  const isFirstPerformance = performanceStore((state) => state.isFirstPerformance);
  const setIsFirstPerformance = performanceStore((state) => state.setIsFirstPerformance);
  const setIsReady = playerStore((state) => state.setIsReady);
  const isReady = playerStore((state) => state.isReady);
  const history = performanceStore((state) => state.history);
  const settingsAutoPlay = settingsStore((state) => state.settings?.autoplay_enabled);

  const isSeeking = playerStore((state) => state.isSeeking);
  const setSeeking = playerStore((state) => state.setSeeking);

  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const isMusicPaused = musicPlayerStore((state) => state.isPaused);
  const isMusicPlaying = musicPlayerStore((state) => state.isPlaying);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);
  const setIsMusicReallyPaused = musicPlayerStore((state) => state.setIsMusicReallyPaused);
  const iosFrom = playerStore((state) => state.iosFrom);
  const setIosFrom = playerStore((state) => state.setIosFrom);

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const screen = window.screen;
  screen.lockOrientationUniversal = (mode) => (screen.orientation && screen.orientation.lock(mode).then(() => {
  }, err => console.log(err))) || (screen.mozLockOrientation && screen.mozLockOrientation(mode)) || (screen.msLockOrientation && screen.msLockOrientation(mode));

  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const options = props.options;

  let pausedPosition = 0;

  const showHomeUse = () => {
    if (timeoutsStore.getState().overlayShowHomeUse) {
      clearTimeout(timeoutsStore.getState().overlayShowHomeUse);
    }
    let timerSecs = (Math.floor(Math.random() * 200) + 60) * 1000;
    //console.log("timerSecs: " + timerSecs);
    let timer = setTimeout(function () {
      const player = playerRef.current;
      if (player) {
        player.trigger("hide_title");
        player.trigger("show_home_use_desc");
        hideHomeUse();
      }
    }, timerSecs);
    timeoutsStore.getState().setOverlayShowHomeUse(timer);
  };

  const hideHomeUse = () => {
    if (timeoutsStore.getState().overlayHideHomeUse) {
      clearTimeout(timeoutsStore.getState().overlayHideHomeUse);
    }
    let timer = setTimeout(function () {
      const player = playerRef.current;
      if (player) {
        player.trigger("show_title");
        player.trigger("hide_home_use_desc");
        showHomeUse();
      }
    }, 5000);
    timeoutsStore.getState().setOverlayHideHomeUse(timer);
  };

  const getLocalCurrentPitch = (performance) => {
    if (performance.track.flags) {
      if (performance.track.flags.includes("voc_avail") && currentVersion === "vocal") {
        return 0;
      }
    }
    return performance.pitch;
  };

  const getLocalCurrentVersion = (performance) => {
    if (performance.track.flags) {
      if (performance.track.flags.includes("voc_avail") && currentVersion === "vocal") {
        return "vocal";
      }
    }
    return "normal";
  };

  const setOverlayCountdown = (countdown) => {
    const fsCountdownEl = document.getElementById("muvika-fullscreen-countdown");
    if (fsCountdownEl) {
      if (countdown > 0) {
        fsCountdownEl.textContent = countdown + "s";
      } else {
        fsCountdownEl.textContent = "";
      }
    }
  };

  const endedFunc = (isAutoplayOn) => {
    setIsPlaying(false);
    setIsStopped(true);
    addPerformanceToHistory(sessionToken, currentPerformance);
    deletePerformance(sessionToken, currentPerformance.unique_id);
    if (isAutoplayOn && isFocused) {
      setIsAutoPlayOn(true);
      let nextPerformance = getNextPerformance();
      if (nextPerformance) {
        setNextPerformance(nextPerformance);
        getStreamUrl(sessionToken, nextPerformance, nextPerformance.track, getLocalCurrentPitch(nextPerformance), getLocalCurrentVersion(nextPerformance), 0, false, false);
        setCountdown(settings.autoplay_secs);
        setOverlayCountdown(settings.autoplay_secs);
        let seconds = settings.autoplay_secs;
        let interval = setInterval(function () {
          let nextPerformanceLocal = nextPerformance;
          if (seconds > 0) {
            setCountdown(seconds);
            setOverlayCountdown(seconds);
            seconds = seconds - 1;
          } else {
            if (nextPerformanceLocal) {
              setCountdown(0);
              setOverlayCountdown(0);
              setCurrentTime(0);
              setNextPerformance(null);
              setIsPlaying(true);
              setIsStopped(false);
              clearInterval(interval);
            }
          }
        }, 1000);
        IntervalService.addInterval(interval, function () {
          setCountdown(0);
          setOverlayCountdown(0);
          setNextPerformance(null);
          clearInterval(interval);
        });
      } else {
        playerStore.getState().softReset();
        IntervalService.clearAllIntervals();
      }
    } else {
      setCurrentTime(0);
    }
  };

  const showPoster = (player) => {
    let posters = player.el().getElementsByClassName("vjs-poster");
    console.log("showPoster", posters.length);
    for (var i = 0; i < posters.length; i++) {
      posters[i].classList.remove("vjs-hidden");
      posters[i].innerHTML = "";
      posters[i].style.display = "block";
      var newElement = posters[i].cloneNode(true);
      newElement.onclick = () => {
        let isPlayerFullscreen = player.isFullscreen();
        if (isPlayerFullscreen) {
          player.controls(true);
          player.controlBar.el().style.display = "flex";
        }
      };
      posters[i].parentNode.replaceChild(newElement, posters[i]);
    }
  };

  const hidePoster = (player) => {
    let posters = player.el().getElementsByClassName("vjs-poster");
    for (var i = 0; i < posters.length; i++) {
      posters[i].style.display = "none";
    }
  };

  const showPlayButton = (player) => {


    let posters = player.el().getElementsByClassName("vjs-big-play-button");
    if (posters.length == 1) {
      posters[0].style.display = "block";
    }
  };

  const setPlayerCurrentTime = (time) => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios' && !playerStore.getState().hasBeenPlayed) {
        console.log("setting current time ios");
        if (!playerStore.getState().isFullScreen) {
          playerStore.getState().setIosFrom(time >= 0 ? time : 0);
        }
      } else {
        console.log("setting current time standard");
        player.currentTime(time);
      }
    }
  };

  const stop = () => {
    const player = playerRef.current;
    if (player) {
      IntervalService.clearAllIntervals();
      if (!playerStore.getState().isStopped.isStopped) {
        playerStore.getState().setIsPlaying(false);
        playerStore.getState().setIsStopped(true);
        player.pause();
      }
      setPlayerCurrentTime(0);
    }
  };

  const next = () => {
    console.log("next");
    const player = playerRef.current;
    if (player) {
      console.log("next");
      setPlayerCurrentTime(0);
      playerStore.getState().setIsAutoPlayOn(true);
      stop();
      performanceStore.getState().addPerformanceToHistory(sessionToken, performanceStore.getState().currentPerformance);
      performanceStore.getState().deletePerformance(sessionToken, performanceStore.getState().currentPerformance.unique_id);
    }
  };

  const prev = () => {
    const player = playerRef.current;
    if (player) {
      playerStore.getState().setIsAutoPlayOn(true);
      playerStore.getState().setIsTrackLogSent(null);
      let currentTimeNow = player.currentTime();
      stop();
      if (performanceStore.getState().history.items.length > 0) {
        if (currentTimeNow == 0) {
          performanceStore.getState().prevFromHistory(sessionToken);
        }
      }
    }
  };

  const backwards10 = () => {
    const player = playerRef.current;
    if (player) {
      if (iosFrom?.from) {
        setPlayerCurrentTime(iosFrom?.from - 10);
      } else {
        setPlayerCurrentTime(player.currentTime() - 10);
      }
    }
  };

  const forwards10 = () => {
    const player = playerRef.current;
    if (player) {
      if (iosFrom?.from) {
        setPlayerCurrentTime(iosFrom?.from + 10);
      } else {
        setPlayerCurrentTime(player.currentTime() + 10);
      }
    }
  };

  const jumpToMusic = () => {
    const player = playerRef.current;
    if (player && performanceStore.getState().currentPerformance) {
      setPlayerCurrentTime(performanceStore.getState().currentPerformance.track.audio_start);
    }
  };

  const setVocColor = () => {
    const player = playerRef.current;
    if (player) {
      let isVocal = isVocalAvailable();
      if (isVocal) {
        if (playerStore.getState().currentVersion === "vocal") {
          let vocsAc = player.el().getElementsByClassName("vjs-muvika-voc");
          if (vocsAc.length == 1) {
            vocsAc[0].className = "vjs-control vjs-muvika-voc-active vjs-muvika-button";
          }
          let vocs = player.el().getElementsByClassName("vjs-muvika-voc-active");
          if (vocs.length == 1) {
            vocs[0].className = "vjs-control vjs-muvika-voc-active vjs-muvika-button";
          }
        } else {
          let vocs = player.el().getElementsByClassName("vjs-muvika-voc-active");
          if (vocs.length == 1) {
            vocs[0].className = "vjs-control vjs-muvika-voc vjs-muvika-button";
          }
          let vocsAc = player.el().getElementsByClassName("vjs-muvika-voc");
          if (vocsAc.length == 1) {
            vocsAc[0].className = "vjs-control vjs-muvika-voc vjs-muvika-button";
          }
        }
      } else {
        let vocs = player.el().getElementsByClassName("vjs-muvika-voc");
        if (vocs.length == 1) {
          vocs[0].className = "vjs-control vjs-muvika-voc vjs-muvika-button vjs-menu-disabled";
        }
        let vocsAc = player.el().getElementsByClassName("vjs-muvika-voc-active");
        if (vocsAc.length == 1) {
          vocsAc[0].className = "vjs-control vjs-muvika-voc vjs-muvika-button vjs-menu-disabled";
        }
      }
    }
  };

  const setAutoPlayState = () => {
    const player = playerRef.current;
    if (player) {
      if (settingsStore.getState().settings?.autoplay_enabled) {
        let vocsAc = player.el().getElementsByClassName("vjs-muvika-autoplay");
        if (vocsAc.length == 1) {
          vocsAc[0].className = "vjs-control vjs-muvika-autoplay-active vjs-muvika-button";
        }
      } else {
        let vocs = player.el().getElementsByClassName("vjs-muvika-autoplay-active");
        if (vocs.length == 1) {
          vocs[0].className = "vjs-control vjs-muvika-autoplay vjs-muvika-button";
        }
      }
    }
  };

  const toVoc = () => {
    const player = playerRef.current;
    if (player) {
      if (playerStore.getState().currentVersion === "vocal") {
        setCurrentVersion("normal");
      } else {
        setCurrentVersion("vocal");
      }
      hidePitchMenu();
      setVocColor();
      setPitchMenuColor();
    }
  };

  const toggleAutoPlay = () => {
    const player = playerRef.current;
    if (player) {
      let sSettings = settingsStore.getState().settings;
      if (sSettings) {
        setIsFirstRender(false);
        let newSettings = { ...sSettings };
        newSettings.autoplay_enabled = !sSettings.autoplay_enabled;
        settingsStore.getState().setSettings(sessionToken, newSettings);
        if (newSettings.autoplay_enabled) {
          let vocsAc = player.el().getElementsByClassName("vjs-muvika-autoplay");
          if (vocsAc.length == 1) {
            vocsAc[0].className = "vjs-control vjs-muvika-autoplay-active vjs-muvika-button";
          }
        } else {
          let vocs = player.el().getElementsByClassName("vjs-muvika-autoplay-active");
          if (vocs.length == 1) {
            vocs[0].className = "vjs-control vjs-muvika-autoplay vjs-muvika-button";
          }
        }
      }
    }
  };

  const setPitchMenuColor = () => {
    const player = playerRef.current;
    if (player) {
      if (playerStore.getState().currentTrack) {
        if (playerStore.getState().currentTrack.flags) {
          if (playerStore.getState().currentTrack.flags.includes("voc_avail")) {
            let versionVersion = playerStore.getState().currentVersion;
            if (versionVersion === "vocal") {
              setPitchLabelDisabled(true);
              let pitchButtons = player.el().getElementsByClassName("vjs-muvika-pitch");
              for (let i = 0; i < pitchButtons.length; i++) {
                pitchButtons[i].className = "vjs-control vjs-muvika-pitch vjs-muvika-button vjs-menu-disabled";
              }
              return;
            }
          }
        }
      }
      let pitchButtons = player.el().getElementsByClassName("vjs-muvika-pitch");
      setPitchLabelDisabled(false);
      for (let i = 0; i < pitchButtons.length; i++) {
        pitchButtons[i].className = "vjs-control vjs-muvika-pitch vjs-muvika-button";
      }
    }
  };

  const hidePitchMenu = () => {
    let menuDom = document.getElementById("vjs-muvika-pitch-menu");
    if (menuDom) {
      menuDom.style.display = "none";
    }
  };

  const togglePitchMenu = () => {
    let menuDom = document.getElementById("vjs-muvika-pitch-menu");
    if (menuDom) {
      if (menuDom.style.display === "" || menuDom.style.display === "none") {
        menuDom.style.display = "block";
      } else {
        menuDom.style.display = "none";
      }
    }
  };

  const setPitchLabel = (pitch) => {
    console.log("setPitchLabel()")
    let items = document.getElementsByClassName("vjs-pitch-label");
    if (items && (pitch || pitch ===0) ) {
      for (var i = 0; i < items.length; i++) {
        items[i].textContent = (pitch > 0 ? "+" : "") + pitch;
      }
    }
  };

  const setPitchLabelDisabled = (isDisabled) => {
    let items = document.getElementsByClassName("vjs-pitch-label");
    if (items) {
      for (var i = 0; i < items.length; i++) {
        if (isDisabled) {
          items[i].className = 'vjs-pitch-label  vjs-menu-disabled';
        } else {
          items[i].className = 'vjs-pitch-label';
        }
      }
    }
  };

  const setPitchItemFocused = (pitch) => {
    setPitchLabel(pitch);
    let items = document.getElementsByClassName("vjs-pitch-menu-item");
    if (items) {
      for (var i = 0; i < items.length; i++) {
        items[i].className = "vjs-menu-item vjs-pitch-menu-item";
      }
    }
    console.log("vjs-pitch-menup" + pitch);
    let itemDom = document.getElementById("vjs-pitch-menup" + pitch);
    if (itemDom) {
      itemDom.className = "vjs-menu-item vjs-pitch-menu-item vjs-pitch-menu-item-active";
    }
  };

  const changeCurrentPitch = (pitch) => {
    if (playerStore.getState().currentPitch !== pitch) {
      setCurrentPitch(pitch);
      setCurrentPerformancePitch(sessionToken, pitch);
    }
    let menuDom = document.getElementById("vjs-muvika-pitch-menu");
    if (menuDom) {
      menuDom.style.display = "none";
    }
    setPitchItemFocused(pitch);
  };

  const addPrevButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().firstChild);
    domButton.className = "vjs-control vjs-muvika-prev vjs-muvika-button";
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      prev();
    });
  };

  const addNextButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().childNodes[2]);
    domButton.className = "vjs-control vjs-muvika-next vjs-muvika-button";
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      next();
    });
  };

  const addBackwardsButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().childNodes[3]);
    domButton.className = "vjs-control vjs-muvika-backwards vjs-muvika-button";
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      console.log("back");
      backwards10();
    });
  };

  const addForwardsButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().childNodes[4]);
    domButton.className = "vjs-control vjs-muvika-forwards vjs-muvika-button";
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      forwards10();
    });
  };

  const addJumpToMusicButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().childNodes[5]);
    domButton.className = "vjs-control vjs-muvika-jumptomusic vjs-muvika-button";
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      jumpToMusic();
    });
  };

  const isVocalAvailable = () => {
    if (playerStore.getState().currentTrack) {
      if (playerStore.getState().currentTrack.flags) {
        return playerStore.getState().currentTrack.flags.includes("voc_avail");
      }
    }
    return false;
  };

  const addVocButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().childNodes[6]);
    if (playerStore.getState().currentVersion === "vocal") {
      domButton.className = "vjs-control vjs-muvika-voc-active vjs-muvika-button";
    } else {
      domButton.className = "vjs-control vjs-muvika-voc vjs-muvika-button";
    }
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      if (isVocalAvailable()) {
        toVoc();
      }
    });
  };

  const addAutoPlayButton = (player) => {


    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    let domButton = player.controlBar.el().insertBefore(button.el(), player.controlBar.el().childNodes[7]);
    if (settingsStore.getState().settings?.autoplay_enabled) {
      domButton.className = "vjs-control vjs-muvika-autoplay-active vjs-muvika-button";
    } else {
      domButton.className = "vjs-control vjs-muvika-autoplay vjs-muvika-button";
    }
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';
    domButton.addEventListener(tapEvent, () => {
      toggleAutoPlay();
    });
  };

  const addPitchMenuButton = (player) => {
    const Button = videojs.getComponent('Button');
    const button = new Button(player);

    const domButton = player.controlBar.el().insertBefore(
      button.el(),
      player.controlBar.el().childNodes[8]
    );

    // Add label next to the button
    const label = document.createElement('span');
    label.className = 'vjs-pitch-label';

    domButton.parentNode.insertBefore(label, domButton.nextSibling);

    if (playerStore.getState().currentVersion !== "vocal") {
      domButton.className = "vjs-control vjs-muvika-pitch vjs-muvika-button";
    } else {
      domButton.className =
        "vjs-control vjs-muvika-pitch vjs-muvika-button vjs-menu-disabled";
    }

    const tapEvent =
      (window.ontouchstart === null) ? 'touchstart' : 'click';

    domButton.addEventListener(tapEvent, () => {
      const versionVersion = playerStore.getState().currentVersion;

      if (playerStore.getState().currentTrack.flags) {
        if (
          playerStore.getState().currentTrack.flags.includes("voc_avail")
        ) {
          if (versionVersion !== "vocal") {
            togglePitchMenu();
          }
        } else {
          togglePitchMenu();
        }
      } else {
        togglePitchMenu();
      }
    });
  };

  const addPitchMenu = (player) => {


    var Menu = videojs.getComponent('Menu');
    let menu = new Menu(player);
    const tapEvent = (window.ontouchstart === null) ? 'touchstart' : 'click';

    var MenuItem = videojs.getComponent('MenuItem');
    let item1 = new MenuItem(player, { label: "+3" });
    item1.controlText("+3");
    item1.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item1.el().id = "vjs-pitch-menup3";
    menu.addItem(item1);
    item1.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(3);
    });

    let item2 = new MenuItem(player, { label: "+2" });
    item2.controlText("+2");
    item2.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item2.el().id = "vjs-pitch-menup2";
    menu.addItem(item2);
    item2.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(2);
    });


    let item3 = new MenuItem(player, { label: "+1" });
    item3.controlText("+1");
    item3.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item3.el().id = "vjs-pitch-menup1";
    menu.addItem(item3);
    item3.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(1);
    });


    let item4 = new MenuItem(player, { label: "0" });
    item4.controlText("0");
    item4.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item4.el().id = "vjs-pitch-menup0";
    menu.addItem(item4);
    item4.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(0);
    });


    let item5 = new MenuItem(player, { label: "-1" });
    item5.controlText("-1");
    item5.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item5.el().id = "vjs-pitch-menup-1";
    menu.addItem(item5);
    item5.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(-1);
    });


    let item6 = new MenuItem(player, { label: "-2" });
    item6.controlText("-2");
    item6.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item6.el().id = "vjs-pitch-menup-2";
    menu.addItem(item6);
    item6.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(-2);
    });


    let item7 = new MenuItem(player, { label: "-3" });
    item7.controlText("-3");
    item7.el().className = "vjs-menu-item vjs-pitch-menu-item";
    item7.el().id = "vjs-pitch-menup-3";
    menu.addItem(item7);
    item7.el().addEventListener(tapEvent, () => {
      changeCurrentPitch(-3);
    });


    let domMenu = player.controlBar.el().insertBefore(menu.el(), player.controlBar.el().childNodes[9]);
    domMenu.id = "vjs-muvika-pitch-menu";
  };

  const addLength = (player) => {
    var Button = videojs.getComponent('Button');
    let button = new Button(player);
    button.el().id = "muvika-fullscreen-player-length";
    const progressIndex = player.controlBar.children().findIndex(
      c => c.name && c.name() === 'ProgressControl'
    );
    player.controlBar.addChild(button, {}, progressIndex + 1);
  };

  const organizeControlBar = (player) => {


    addPrevButton(player);
    addNextButton(player);
    addBackwardsButton(player);
    addForwardsButton(player);
    addJumpToMusicButton(player);
    addVocButton(player);
    addAutoPlayButton(player);
    addPitchMenuButton(player);
    addPitchMenu(player);
    addLength(player);
  };

  const lockScreenOrientation = (mode) => {
    if (Capacitor.isNativePlatform()) {
      if (window.screen) {
        if (window.screen.orientation) {
          if (window.screen.orientation.lock) {
            window.screen.orientation.lock(mode);
          }
        }
      }
    }
  };

  const fullscreenPlayButtonPlay = () => {
    const playElements = document.getElementsByClassName("vjs-play-control vjs-control vjs-button");
    console.log("buttons", playElements);
    console.log("buttons", playElements.length);
    if (playElements.length > 0) {
      let elClone = playElements[0].cloneNode(true);
      playElements[0].parentNode.replaceChild(elClone, playElements[0]);
      elClone.onclick = (e) => {
        if (isReady) {
          setIsReady(false);
          //playElements[0].onclick(e);
        }
      };
    }
  };

  const fullscreenPauseButtonPause = () => {
    const pauseElements = document.getElementsByClassName("vjs-playing");
    if (pauseElements.length > 0) {
      let elClone = pauseElements[0].cloneNode(true);
      pauseElements[0].parentNode.replaceChild(elClone, pauseElements[0]);
      elClone.onclick = (e) => {
        if (isReady) {
          setIsReady(false);
          //pauseElements[0].onclick(e);
        }
      };
    }
  };

  const setPlayerVolume = (volume) => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        if (isMusicReallyPaused.isPaused) {
          IosVolumeControl.setDeviceVolume(volume);
        }
      } else {
        player.volume(volume);
      }
    }
  };

  const getPlayerVolume = () => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        return IosVolumeControl.getDeviceVolume();
      } else {
        return player.volume();
      }
    }
  };

  function hideBarsSoft() {
    const top = document.querySelector('.muvika-app-bar');
    const bottom = document.querySelector('#muvika-bottom-bar');

    if (top) top.style.visibility = 'hidden';
    if (bottom) bottom.style.visibility = 'hidden';
  }

  function showBarsSoft() {
    const top = document.querySelector('.muvika-app-bar');
    const bottom = document.querySelector('#muvika-bottom-bar');

    if (top) top.style.visibility = 'visible';
    if (bottom) bottom.style.visibility = 'visible';
  }

  function showControlsOnce(player) {
    if (!player) return;

    // 1. Force Video.js to think the user is active
    player.userActive_ = true;

    // 2. Show the control bar immediately
    player.controlBar.show();

    // 3. Reset internal inactivity timer so fade-out starts from now
    if (player.inactivityTimeout) {
      clearTimeout(player.inactivityTimeout);
      player.inactivityTimeout = setTimeout(() => {
        player.userActive(false);
        player.controlBar.hide();
      }, player.options_.inactivityTimeout || 2000); // fallback 2s
    }
  }

  const setFullscreenOverlayMode = () => {
    const overlayEls = document.getElementsByClassName("muvika-overlay-title");
    if (overlayEls) {
      for (let i = 0; i < overlayEls.length; i++) {
        console.log("overlayEl", overlayEls[i]);
        overlayEls[i].style.fontSize = "2rem";
      }
    }
  };

  const setNormalOverlayMode = () => {
    const overlayEls = document.getElementsByClassName("muvika-overlay-title");
    if (overlayEls) {
      for (let i = 0; i < overlayEls.length; i++) {
        overlayEls[i].style.fontSize = "0.81rem";
      }
    }
  };

  const initPlayer = () => {
    const videoElement = document.createElement("video-js");
    videoElement.onclick = (e) => {


      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    };

    videoElement.classList.add('video-js');
    videoRef.current.appendChild(videoElement);
    const player = playerRef.current = videojs(videoElement, options, () => {
    });

    if (Capacitor.getPlatform() !== 'ios') {
      player.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: false,
          exitOnRotate: false,
          alwaysInLandscapeMode: true,
          iOS: false
        }
      });
    }

    organizeControlBar(player);
    player.aspectRatio("16:9");
    setPlayerVolume(currentVolume.currentVolume);

    let plEvent = player.controlBar.getChild('playToggle').handleClick;
    player.controlBar.getChild('playToggle').handleClick = () => {
      if (playerStore.getState().isReady) {
        playerStore.getState().setIsReady(false);
        if (player.paused()) {
          player.play();
        } else {
          player.pause();
        }
      }
    };
    console.log("playToggle", plEvent);
    console.log("playToggle", player.controlBar.getChild('playToggle').handleClick);

    /*      var oldPlayToggle = player.controlBar.getChild('playToggle').el();
         var newPlayToggle = oldPlayToggle.cloneNode(true);
         newPlayToggle.onclick=() => {
          if (isReady) {
            setIsReady(false);
            player.controlBar.getChild('playToggle').el().click();
          }
         }
         oldPlayToggle.parentNode.replaceChild(newPlayToggle, oldPlayToggle); */

    player.controlBar.removeChild(player.controlBar.getChild('PictureInPictureToggle'));
    const audioButton = player.controlBar.getChild("AudioTrackButton");
    player.controlBar.removeChild(audioButton);
    showPoster(player);
    showPlayButton(player);
    if (!checkIfMobile()) {
      if (muvikaAttrs.service === "muvika") {
        player.watermark({
          image: "./muvika-logo-gray-20.png",
          position: "top-left",
          xpos: 0,
          ypos: 0,
          xrepeat: 0,
          opacity: 100,
          clickable: false,
          className: 'vjs-watermark'
        });
      }
    }

    if (props.isCustomer) {
      showHomeUse();
    }

    const origFocus = videoElement.focus;

    // Override it
    videoElement.focus = function (options) {
      if (origFocus) {
        // Force preventScroll whenever focus is called
        origFocus.call(videoElement, { preventScroll: true });
      }
    };

    player.on('seeking', () => {
      setSeeking(true);
      console.log("seeking");
    });

    player.on('seeked', () => {
      setSeeking(false);
      showControlsOnce();
      console.log("seeking seeked", playerStore.getState().isPlaying.isPlaying);
    });

    player.on('playing', function () {
      console.log("is seeking seeked", playerStore.getState().isPlaying.isPlaying);
      if (playerStore.getState().isSeeking) return;
      playerStore.getState().setHasBeenPlayed(true);
      playerStore.getState().setIsReady(true);
      playerStore.getState().setIsSwitching(false);
      if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
        setPlayerVolume(1);
      } else {
        setPlayerVolume(playerStore.getState().currentVolume.currentVolume);
      }
      hidePoster(player);
      setIsPlaying(true);
      setIsStopped(false);
      setPlayerStatus(sessionToken, "streaming");
      IntervalService.clearAllIntervals();
      player.trigger("hide_title");
    });

    player.on(['pause'], function () {
      if (playerStore.getState().isSeeking) return;
      playerStore.getState().setIsReady(true);
      playerStore.getState().setIsSwitching(false);
      if (playerStore.getState().isFullScreen) {
        player.controls(true);
      }
      console.log("isPaused");
      setIsPlaying(false);
      setPlayerStatus(sessionToken, "paused");
      player.trigger("show_title");
    });

    player.on('enterFullWindow', () => {
      console.log("entered fullwindow");
      setFullscreenOverlayMode();
      setFullScreen(true);
      setVocColor();
      setAutoPlayState();
      setPitchItemFocused(performanceStore.getState().currentPerformance?.pitch);
      hidePitchMenu();
      setPitchMenuColor();
      player.controls(true);
      setAppStatus(sessionToken, "fullscreen");
      hideBarsSoft();

      let videoTags = document.getElementsByTagName("video");
      if (videoTags.length > 0) {
        for (let i = 0; i < videoTags.length; i++) {
          videoTags[i].onclick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            hidePitchMenu();
          };
        }
      }
    });

    player.on('exitFullWindow', () => {
      console.log("exited fullwindow");
      lockOrientation();
      setTimeout(() => {
        setVocColor();
        setAutoPlayState();
        setNormalOverlayMode();
        setPitchItemFocused(performanceStore.getState().currentPerformance?.pitch);
        hidePitchMenu();
        setPitchMenuColor();
        player.controls(false);
        setFullScreen(false);
        setAppStatus(sessionToken, "mainwindow");
        window.dispatchEvent(new Event('refitbuttons'));
        window.dispatchEvent(new Event('resize'));
        showBarsSoft();
        setPaddingBottom("muvika-performances-list", -35);
      }, 700);
    });

    player.on('fullscreenchange', function () {
      console.log("fullscreen");
      //fullscreenPlayButtonPlay();
      //fullscreenPauseButtonPause();

      setVocColor();
      setAutoPlayState();
      setPitchItemFocused(performanceStore.getState().currentPerformance?.pitch);
      hidePitchMenu();
      setPitchMenuColor();
      let isPlayerFullscreen = player.isFullscreen();
      /*       if (isIPhone()) {
              setFullScreen(isPlayerFullscreen);
              player.controls(isPlayerFullscreen);
              if (isPlayerFullscreen) {
                setAppStatus(sessionToken, "fullscreen");
              } else {
                player.exitFullWindow();
                lockScreenOrientation("portrait");
                setAppStatus(sessionToken, "mainwindow");
                window.dispatchEvent(new Event('refitbuttons'));
                window.dispatchEvent(new Event('resize'));
                setPaddingBottom("muvika-performances-list", -35);
              }
            } else { */
      let videoTags = document.getElementsByTagName("video");
      if (videoTags.length > 0) {
        for (let i = 0; i < videoTags.length; i++) {
          videoTags[i].onclick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            hidePitchMenu();
          };
        }
      }
      player.controls(isPlayerFullscreen);
      setFullScreen(isPlayerFullscreen);
      if (isPlayerFullscreen) {
        setFullscreenOverlayMode();
        setAppStatus(sessionToken, "fullscreen");
      } else {
        setNormalOverlayMode();
        lockOrientation();
        setAppStatus(sessionToken, "mainwindow");
      }
      //}
      if (!isPlayerFullscreen) {
        setTimeout(() => {
          window.dispatchEvent(new Event('refitbuttons'));
          window.dispatchEvent(new Event('resize'));
          setPaddingBottom("muvika-performances-list", -35);
        }, 500);
      }
    });

    player.on('volumechange', function () {
      let isPlayerFullscreen = player.isFullscreen();
      if (isPlayerFullscreen) {
        if (player.muted()) {
          setPlayerVolume(0);
          player.muted(false);
        }
        setVolume(getPlayerVolume());
        if (settings) {
          let newSettings = { ...settings };
          newSettings.volume = Math.round(getPlayerVolume() * 100);
          setSettings(sessionToken, newSettings, false);
        }
      }
    });

    player.on('progress', function () {
      let buffEnd = player.bufferedEnd();
      setCurrentBuffer(buffEnd / player.duration());
    });


    if (props.isExternal) {
      player.fill(true);
    } else {
      player.fill(false);
    }

    player.bigPlayButton.on('click', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
    });

    if (Capacitor.getPlatform() === 'ios') {
      const volumePanel = player.controlBar.getChild('VolumePanel');
      if (volumePanel) player.controlBar.removeChild(volumePanel);
    }

    if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
      setPlayerVolume(1);
    }

    if (Capacitor.getPlatform() === 'ios') {
      const fsBtnEl = player.controlBar?.fullscreenToggle?.el();
      console.log("fullscreen toggle", fsBtnEl);
      if (fsBtnEl) {
        // Clone the button to remove all old event listeners
        const newBtn = fsBtnEl.cloneNode(true);

        // Replace the original button with the clean clone
        fsBtnEl.parentNode.replaceChild(newBtn, fsBtnEl);

        // Override click: always exit fullscreen on iOS
        newBtn.addEventListener('click', function (e) {
          console.log("fullscreen click");
          player.exitFullWindow(); // Correct video.js method
        });

      }
    }

    player.playsinline(true);
    window.dispatchEvent(new Event('refitbuttons'));
  };

  useEffect(() => {
    if (!playerRef.current) {
      initPlayer();
      initEmptyOverlay();
      checkPlayQueue();
    } else {
    }
  });

  const showWatermark = (player) => {


    let posters = player.el().getElementsByClassName("vjs-watermark-content");
    if (posters.length == 1) {
      posters[0].style.display = "block";
    }
  };

  const hideWatermark = (player) => {


    let posters = player.el().getElementsByClassName("vjs-watermark-content");
    if (posters.length == 1) {
      posters[0].style.display = "none";
    }
  };

  const checkPlayQueue = () => {
    if (playQueue) {
      const player = playerRef.current;
      if (player) {
        if (playQueue.items.length == 0) {
          player.trigger("playqueue_empty");
          player.trigger("hide_title");
          player.trigger("hide_home_use_desc");
          clearInterval(timeoutsStore.getState().overlayShowHomeUse);
          clearInterval(timeoutsStore.getState().overlayHideHomeUse);
        } else {
          player.trigger("playqueue_populated");
          if (props.isCustomer) {
            showHomeUse();
          }
        }
      }
    }
  };

  useEffect(() => {
    checkPlayQueue();
  }, [playQueue]);

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  const [isVolumeSetFromSettings, setVolumeSetFromSettings] = useState(false);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (settings) {
        player.off('ended');
        player.one('ended', () => endedFunc(settings.autoplay_enabled));
        if (!isVolumeSetFromSettings) {
          if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
            if (settings.volume) {
              if (currentVolume.currentVolume == 0) {
                setVolumeSetFromSettings(true);
                setVolume(settings.volume / 100);
                setPlayerVolume(settings.volume / 100);
              }
            }
          } else {
            setPlayerVolume(1);
          }
        }

      }
    }
  }, [settings]);

  useEffect(() => {
    if (!isFirstRender) {
      if (settingsAutoPlay && (isStopped.isStopped || (playerStore.getState().currentTime == 0 && !isPlaying.isPlaying))) {
        if (isFirstPerformance) {
          setIsFirstPerformance(null);
        } else {
          runCountdown();
        }
      } else if (!settingsAutoPlay) {
        IntervalService.clearAllIntervals();
      }
    }
    setIsAutoPlayOn(settingsAutoPlay);
  }, [settingsAutoPlay]);

  useEffect(() => {
    console.log("isReady isReady", isReady);
  }, [isReady]);

  useEffect(() => {
    const player = playerRef.current;
    if (player && currentTrack) {
      if (currentPerformance.track.flags) {
        if (currentPerformance.track.flags.includes("voc_avail")) {
          console.log("currentVersion", currentVersion);
          showPoster(player);
          let savedCurrentTime = playerStore.getState().currentTime;
          let versionVersion = currentVersion;
          let versionPitch = getLocalCurrentPitch(currentPerformance);
          if (currentTrack.flags) {
            if (currentTrack.flags.includes("voc_avail")) {
              if (versionVersion === "vocal") {
                versionPitch = 0;
              }
            } else {
              if (versionVersion === "vocal") {
                versionVersion = "normal";
              }
            }
          } else {
            versionVersion = "normal";
          }
          getStreamUrl(sessionToken, currentPerformance, currentTrack, versionPitch, versionVersion, savedCurrentTime, isPlaying.isPlaying, false);
        }
      }
    }
  }, [currentVersion]);

  useEffect(() => {
    if (pitchRecog) {
      const player = playerRef.current;
      console.log("test get stream url r", pitchRecog.currentPitch, isPitchEditable);
      if (player && currentTrack && isPitchEditable) {
        console.log("set currentPitch", pitchRecog.currentPitch);
        showPoster(player);
        let savedCurrentTime = playerStore.getState().currentTime;
        let versionVersion = currentVersion;
        let versionPitch = getLocalCurrentPitch(currentPerformance);
        if (currentTrack.flags) {
          if (currentTrack.flags.includes("voc_avail")) {
            if (versionVersion === "vocal") {
              versionPitch = 0;
            }
          } else {
            if (versionVersion === "vocal") {
              versionVersion = "normal";
            }
          }
        } else {
          versionVersion = "normal";
        }
        console.log("test get stream url", versionVersion, versionPitch);
        getStreamUrl(sessionToken, currentPerformance, currentTrack, versionPitch, versionVersion, savedCurrentTime, isPlaying.isPlaying, false);
      }
    }
  }, [pitchRecog]);

  const runCountdown = () => {
    if (currentPerformance && !nextPerformance && isFocused) {
      //console.log("running countdown");
      IntervalService.clearAllIntervals();
      setNextPerformance(currentPerformance);
      getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, false, false);
      setCountdown(settings.autoplay_secs);
      setOverlayCountdown(settings.autoplay_secs);
      let seconds = settings.autoplay_secs;
      let interval = setInterval(function () {
        let nextPerformanceLocal = currentPerformance;
        if (seconds > 0) {
          setCountdown(seconds);
          setOverlayCountdown(seconds);
          seconds = seconds - 1;
        } else {
          if (nextPerformanceLocal) {
            setCountdown(0);
            setOverlayCountdown(0);
            setCurrentTime(0);
            setNextPerformance(null);
            setIsPlaying(true);
            setIsStopped(false);
            clearInterval(interval);
          }
        }
      }, 1000);
      IntervalService.addInterval(interval, function () {
        setCountdown(0);
        setOverlayCountdown(0);
        setNextPerformance(null);
        clearInterval(interval);
      });
    }
  };

  const initExternalOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<div class="home_use_only_overlay external muvika-overlay-title">' + TR.cm_karaoke_for_home_use_only + '</div>',
          start: 'show_home_use_desc',
          end: 'hide_home_use_desc',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  const initOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<div class="muvika-overlay-title">' + currentPerformance.profile.name + " - " + currentPerformance.track.title + ' <span id="muvika-fullscreen-countdown"></span></div>',
          start: 'show_title',
          end: 'hide_title',
          align: 'top',
          showBackground: false
        }, {
          content: '<div class="home_use_only_overlay muvika-overlay-title">' + TR.cm_karaoke_for_home_use_only + '</div>',
          start: 'show_home_use_desc',
          end: 'hide_home_use_desc',
          align: 'top',
          showBackground: false
        }, {
          content: '<div class="muvika-overlay-title">' + TR.cm_playlist_is_empty + '</div>',
          start: 'playqueue_empty',
          end: 'playqueue_populated',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  const initEmptyOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<div class="muvika-overlay-title">' + TR.cm_playlist_is_empty + '</div>',
          start: 'playqueue_empty',
          end: 'playqueue_populated',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      player.off('timeupdate', function () { });
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      if (currentPerformance) {
        console.log("showPoster currentPerformance");
        if (props.isExternal) {
          initExternalOverlay();
        } else {
          initOverlay();
        }
        if (playerStore.getState().isFullScreen) {
          setFullscreenOverlayMode();
        } else {
          setNormalOverlayMode();
        }
        player.trigger("show_title");
        console.log("currentPerformance", currentPerformance.pitch, isPlaying.isPlaying);
        if (currentPerformanceId) {
          if (currentPerformanceId != currentPerformance.unique_id) {
            showPoster(player);
            if (settings.autoplay_enabled && isAutoPlayOn.isAutoPlayOn) {
              runCountdown();
            } else {
              getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, isPlaying.isPlaying, false);
            }
          } else {
            if (currentPerformance.track.track_id === currentTrack?.track_id) {
              hidePoster(player);
              if (currentPitch !== currentPerformance.pitch) {
                setCurrentPitch(currentPerformance.pitch);
              }
            } else {
              getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, isPlaying.isPlaying, false);
            }
          }
        } else {
          showPoster(player);
          if (settings.autoplay_enabled && isAutoPlayOn.isAutoPlayOn && !isFirstPerformance) {
            runCountdown();
          } else {
            setIsFirstPerformance(null);
            getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, getLocalCurrentPitch(currentPerformance), getLocalCurrentVersion(currentPerformance), 0, isPlaying.isPlaying, false);
          }
        }
        let lengthDom = document.getElementById("muvika-fullscreen-player-length");
        lengthDom.innerHTML = getLength(currentPerformance.track);
      } else {
        IntervalService.clearAllIntervals();
        setCountdown(0);
        setOverlayCountdown(0);
        setNextPerformance(null);
        player.src();
        playerStore.getState().softReset();
        console.log("showPoster currentPerformance null");
        showPoster(player);
        player.bigPlayButton.show();
      }
    }
  }, [currentPerformance]);

  const toMMSS = (secs) => {


    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  const lengthToMinutes = (length) => {


    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const getLength = (track) => {


    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (streamUrl !== "") {
        setVocColor();
        setAutoPlayState();
        setPitchItemFocused(performanceStore.getState().currentPerformance?.pitch);
        hidePitchMenu();
        setPitchMenuColor();
        player.src(streamUrl);
        setSeeking(false);
        playerStore.getState().setHasBeenPlayed(false);
        if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
          console.log("progressControl: disable");
          const progress = player.controlBar?.progressControl;
          progress.disable();
        }
        /* if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios") {
          playerStore.getState().setIosPlayPauseHackOn(true);
          player.muted(true);
          player.play().finally(() => {
            player.pause();
            player.muted(false);
            playerStore.getState().setIosPlayPauseHackOn(false);
            showPoster(player);
            player.bigPlayButton.show();
          })
        }  */
        if (!currentVolume.doNotPropagate) {
          setPlayerVolume(currentVolume.currentVolume);
        }
        setPlayerCurrentTime(playerStore.getState().currentTime);
        let currentTimeDoms = document.getElementsByClassName("vjs-current-time-display");
        if (currentTimeDoms.length > 0) {
          //currentTimeDoms[0].innerHTML = toMMSS(setPlayerCurrentTime());
        }
        player.off('ended');
        player.one('ended', () => endedFunc(isPlayListOn));
        player.off('timeupdate', function () { });
        player.one('timeupdate', function () {
          if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
            console.log("progressControl: enable");
            const progress = player.controlBar?.progressControl;
            progress.enable();
            if (playerStore.getState().iosFrom?.from && playerStore.getState().iosFrom?.from != 0) {
              console.log("set iosFrom from", playerStore.getState().iosFrom.from);
              player.currentTime(playerStore.getState().iosFrom.from);
              playerStore.getState().setIosFrom(null);
            }
          } else {
            playerStore.getState().setIosFrom(null);
          }
        });
        player.on('timeupdate', throttle(function () {
          let currentTimeDoms = document.getElementsByClassName("vjs-current-time-display");
          if (currentTimeDoms.length > 0) {
            //currentTimeDoms[0].innerHTML = toMMSS(setPlayerCurrentTime());
          }
          setCurrentTime(player.currentTime());
          if (performanceStore.getState().currentPerformance && playerStore.getState().currentTrack) {
            if (!playerStore.getState().isTrackLogSent && player.currentTime() >= 30 && !playerStore.getState().isSwitching && !playerStore.getState().isStopped.isStopped) {
              console.log("track log set " + player.currentTime(), playerStore.getState().currentTime);
              console.log(playerStore.getState().isTrackLogSent + " " + performanceStore.getState().currentPerformance.unique_id);
              playerStore.getState().setIsTrackLogSent(performanceStore.getState().currentPerformance.unique_id);
              MuvikaService.setTrackLog(sessionToken, playerStore.getState().currentTrack, getLocalCurrentPitch(performanceStore.getState().currentPerformance), performanceStore.getState().currentPerformance.profile.id, "embedded");
            }
          }
        }, 500));
        player.on('canplay', function () {
          if (playerStore.getState().currentTime == 0) {
            console.log("track log set null", playerStore.getState().isTrackLogSent, performanceStore.getState().currentPerformance.unique_id);
            if (playerStore.getState().isTrackLogSent !== performanceStore.getState().currentPerformance.unique_id) {
              playerStore.getState().setIsTrackLogSent(null);
            }
            player.off('canplay');
          }
        });
      } else {
        IntervalService.clearAllIntervals();
        setCountdown(0);
        setOverlayCountdown(0);
        setNextPerformance(null);
        player.src();
        playerStore.getState().softReset();
        console.log("showPoster currentPerformance null");
        showPoster(player);
        player.bigPlayButton.show();
      }
    } else {
      IntervalService.clearAllIntervals();
      setCountdown(0);
      setOverlayCountdown(0);
      setNextPerformance(null);
      player.src();
      console.log("showPoster streamUrl");
      showPoster(player);
      player.bigPlayButton.show();
    }
  }, [streamUrl]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!isPlayListOn) {
        //player.reset();
      }
    }
  }, [isPlayListOn]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("isReady isReady 2", isReady);
      console.log("player playing", isPlaying.isPlaying, isSwitching, isSeeking);
      if (!isSeeking) {
        if (isPlaying.isPlaying && !isSwitching) {
          console.log("isPlayingPlayer", isMusicOn, isMusicPlaying.isPlaying);
          if (isMusicReallyPaused.isPaused) {
            setIsReady(true);
            player.play();
          }
        } else {
          setIsReady(true);
          player.bigPlayButton.show();
          player.pause();
        }
      }
    }
  }, [isPlaying]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("isReady isReady 1", isReady);
      console.log("isPlayingPlayer", isMusicReallyPaused.isPaused);
      if (isPlaying.isPlaying && !isSwitching && isMusicReallyPaused.isPaused) {
        player.play();
      }
    }
  }, [isMusicReallyPaused]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      setPlayerCurrentTime(from.from);
    }
  }, [from]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.getPlatform() === 'ios') {
        console.log("fullscreen", isFullScreen, player.supportsFullScreen());
        if (isFullScreen && player.supportsFullScreen()) {
          player.enterFullWindow();
          lockScreenOrientation("landscape");
        }
      } else {
        console.log("init fullscreen");
        player.isFullscreen(isFullScreen);
        if (isFullScreen) {
          console.log("requesting fullscreen");
          player.requestFullscreen();
        }
      }
    }
  }, [isFullScreen]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!currentVolume.doNotPropagate) {
        setPlayerVolume(currentVolume.currentVolume);
      }
    }
  }, [currentVolume]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("isReady isReady 3", isReady);
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      if (isStopped.isStopped) {
        if (currentPerformance) {
          console.log("track log set null", playerStore.getState().isTrackLogSent, currentPerformance.unique_id);
          if (playerStore.getState().isTrackLogSent !== currentPerformance.unique_id) {
            playerStore.getState().setIsTrackLogSent(null);
          }
        } else {
          playerStore.getState().setIsTrackLogSent(null);
        }
        console.log("showPoster isStopped");
        showPoster(player);
        player.trigger("stop");
        setPlayerStatus(sessionToken, "stopped");
        player.bigPlayButton.show();
      } else {
        hidePoster(player);
        player.bigPlayButton.hide();
      }
    }
  }, [isStopped]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (isSmallVideo) {
        hideWatermark(player);
      } else {
        showWatermark(player);
      }
    }
  }, [isSmallVideo]);

  return (
    <div className={props.className} style={props.style} data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default VideoPlayer;